module.exports = __webpack_public_path__ + "bd3e96c0b503c42c75f6c87ec35f8719.pdf";